export const orderDetailsEn = {};

export const orderDetailsFr = {};
